export const navItems = [
  {
    key: 'home',
    route: '',
    label: 'Home',
  },
  {
    key: 'about',
    route: 'about',
    label: 'About',
  },
  {
    key: 'platform',
    route: 'platform',
    label: 'Platform',
  },
  {
    key: 'applications',
    route: 'applications',
    label: 'Applications',
  },
  {
    key: 'buzz',
    route: 'buzz',
    label: 'Buzz',
  },
];

export const languages = [
  {
    value: 'fr',
    label: '🇫🇷 FR',
  },
  {
    value: 'en',
    label: '🇬🇧 EN',
  },
];
